import React, { useMemo, useState } from 'react';
import { PopupModal } from 'react-calendly';
import { useNavigate } from 'react-router-dom';
import { Button, Typography } from 'tfc-components';

import AgentSection from './AgentSection';
import BannerSection from './BannerSection';
import FaqSection from './FaqSection';
import Feature from './Feature';
import FeatureInside from './FeatureInside';
import UseCaseSection from './UseCaseSection';

import backgroundBanner from 'assets/images/home/bg-banner1.png';
import Banner from 'components/organisms/Banner';
import Section from 'components/organisms/Section';
import { pricingPlans1, pricingPlans2 } from 'pages/PricingPlan';
import FreeTrial from 'pages/PricingPlan/FreeTrialModal';
import PricingList from 'pages/PricingPlan/PricingList';
import { ROUTE_PATHS } from 'utils/constants';
import mapModifiers from 'utils/functions';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenFreeModal, setIsOpenFreeModal] = useState(false);
  const [activeTab, setActiveTab] = useState<'monthly' | 'annually'>('monthly');
  const pricingPlan = useMemo(() => (activeTab === 'monthly' ? pricingPlans1 : pricingPlans2), [activeTab]);

  const handleOpenModal = (planName: string) => {
    if (planName !== 'Enterprise' && planName !== 'Free trial') {
      navigate(`${ROUTE_PATHS.CHECKOUT}?planName=${planName}`);
    } else if (planName === 'Free trial') {
      setIsOpenFreeModal(true);
    } else {
      setIsOpen(true);
    }
  };

  return (
    <div className="p-home">
      <BannerSection onOpenModal={() => setIsOpen(true)} />
      <Feature />
      {/* <UseCaseSection /> */}
      <UseCaseSection />
      <FeatureInside />
      <div className="p-home_background">
        <AgentSection />
      </div>
      <Section className="p-pricingPlan">
        <Section.Title sectionName="Pricing" className="p-pricingPlan_titleSection">
          Ask2Auto pricing
        </Section.Title>
        <div className={mapModifiers('p-pricingPlan_tabs', activeTab === 'annually' && 'right')}>
          {['monthly', 'annually'].map((tab) => (
            <Button
              key={tab}
              extendClasses={`p-pricingPlan_tab p-pricingPlan_tab-${activeTab === tab ? 'active' : ''} ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab as 'monthly' | 'annually')}
            >
              {tab === 'monthly' && <Typography.Text fontweight="600">Monthly</Typography.Text>}
              {tab === 'annually' && <Typography.Text fontweight="600">Annually</Typography.Text>}
            </Button>
          ))}
        </div>
        <div className="p-pricingPlan_descriptionContainer">
          <Typography.Text fontweight="600" extendClasses="p-pricingPlan_description fs-14x20">Price in VND</Typography.Text>
        </div>
        <PricingList plans={pricingPlan} handleOpenModal={handleOpenModal} />
      </Section>
      <FaqSection isHomePage />
      <div className="p-home_bannerItem">
        <Banner
          backgroundImage={backgroundBanner}
          title="Get started with the Ask2Auto today"
          content={(
            <>
              Explore our features and share your feedback or
              <br />
              questions with a demo meeting.
            </>
          )}
          buttonPrimary={{
            label: 'Book demo now',
            action: () => {
              setIsOpen(true);
            },
          }}
        />
      </div>
      <PopupModal
        pageSettings={{ primaryColor: '#f96619' }}
        open={isOpen}
        onModalClose={() => setIsOpen(false)}
        url="https://calendly.com/askly-demo/schedule?hide_gdpr_banner=1"
        rootElement={document.getElementById('root') || document.body}
      />
      <FreeTrial isOpen={isOpenFreeModal} onClose={() => setIsOpenFreeModal(false)} />
    </div>
  );
};

export default Home;
